import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { useModal } from "../../contexts/ModalContext";
import BookingPopup from '../../components/BookingPopup';

export default function HomeBanner() {
  const [showSerachEngine, setshowSerachEngine] = useState(false);
  const { openQueryModal } = useModal();
  const videoRef = useRef(null);

  useEffect(() => {
    // Manually trigger play after mount to avoid double-fetch from autoPlay + preload
    const video = videoRef.current;
    if (video) {
      video.play().catch(() => {});
    }
  }, []);

  return (
    <>

      <section className="banner-area">
        <div className="banner-slides">
          <div className="banner-cols">
            <video
              ref={videoRef}
              className="home-video"
              poster="/assets/images/home-banner-poster.jpg"
              preload="none"
              loop
              muted
              playsInline
            >
              <source src="/assets/video/home-banner.mp4" type="video/mp4" />
            </video>
            <div className="container banner-content">
              <div className="row content-inner banner-row">
                <div className="col-sm-12 col-md-6 col-lg-7">
                  <div className="banner-text">
                    <h1 className="heading">Reliable Dumpster Rentals</h1>
                    <div className="content-text">
                      <p>Fast, affordable dumpster rentals designed for homeowners, contractors, and businesses keeping every cleanup simple, smooth, and stress-free.</p>
                    </div>

                    <div className="banner-btn">
                      <Link className="theme-btn white-btn" to="/contact-us/"> <span className="color-overlay"></span> <span className="btn-txt">Contact us</span></Link>
                      {/* <Link className="theme-btn" to="/about-us/"><span className="color-overlay"></span> <span className="btn-txt"> Know More</span></Link> */}
                    </div>
                  </div>
                </div>

                <div className="col-sm-12 col-md-6 col-lg-5">
                  <div className="book-now-btn">
                    <div className="btn-area first-btn">
                      <div className="img-text">
                        <div className="icon-wraps">
                          <img src="/assets/images/call-icons.webp" alt="Call" className="img-responsive call-phone" />
                        </div>
                        <div className="text-area">
                          <p className="call-text">Call Us Now</p>
                          <Link className="call-text" to="tel:+1 780 230 1359">+1 780 230 1359</Link>
                        </div>
                      </div>
                    </div>
                    <div className="btn-area last-btn">
                      <Link className="img-text" onClick={() => setshowSerachEngine(true)} >
                        <div className="icon-wraps">
                          <img src="/assets/images/book-icon.webp" alt="Call" className="img-responsive call-phone" />
                        </div>
                        <div className="text-area">
                          <p className="call-text">Book Online</p>
                        </div>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="header-social-wrap">
          <div className="header-social">
            <ul className="social-items">
              <li>
                <Link to=""><img src="/assets/images/linkdin-icon.webp" alt="Linkdin" className="img-responisve"></img></Link>
              </li>
              <li>
                <Link><img src="/assets/images/phone-icons.webp" alt="Linkdin" className="img-responisve"></img></Link>
              </li>
              <li>
                <Link><img src="/assets/images/mail-icons.webp" alt="Linkdin" className="img-responisve"></img></Link>
              </li>
            </ul>
          </div>
        </div>
      </section>
      <BookingPopup isOpen={showSerachEngine} onClose={() => setshowSerachEngine(false)} />
    </>
  )
}
